import { UrlConstants } from "../url.constants";
export class ApiApplicationConstants {
    static URL = UrlConstants.API_V2 + "Application";
    static FUNCTION_CHANGE_OWNER = "ChangeOwner";
}
